import { render, staticRenderFns } from "./DHWSPlayerControl.vue?vue&type=template&id=4a6757a8"
import script from "./DHWSPlayerControl.vue?vue&type=script&lang=js"
export * from "./DHWSPlayerControl.vue?vue&type=script&lang=js"
import style0 from "./DHWSPlayerControl.vue?vue&type=style&index=0&id=4a6757a8&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports